<script>
import Base from "@/components/RequestDetailsForDefaultVue/FundData.vue";

export default {
  name: "CustomerServiceFilesFundData",
  extends: Base,
};
</script>
